import React, {Component, useEffect, useState} from 'react';
import './ChangePass.css';
import { FaUserAlt, FaLock, FaEnvelope, FaUserLock, FaUserTie, FaUniversity } from "react-icons/fa";
import back from '../../assets/Group 1.svg';
import queryString from 'query-string'

import { useMutation } from '@apollo/client';
import { CHANGE_PASS } from '../../queries'

const ChangePass = (props) => {
    const values = queryString.parse(props.location.search)
    const [ changePass, { data, /*loading,*/ error }] = useMutation(CHANGE_PASS);

    const [errorLog, setErrorLog] = useState('');
    useEffect(()=>{
        console.log(error)
        if(error) {
            setErrorLog(error.message);
        }
    }, [error]);

  return (
    <ChangePassForm errorLog={errorLog}  token={values.token} changePass={changePass}/>
  )
}


class ChangePassForm extends Component{
    constructor(props) {
        super(props);
        this.state = {
            pass: '',
            repass: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        // this.handleValidation = this.handleValidation.bind(this);
    }

    handleValidation(){
        if (!this.state.pass
            || !this.state.repass){
                console.log("bisa");
                this.setState({
                    errorForm: "Isi Form!",
                }, () => alert(this.state.errorForm))
                return 0;
            }
        if (this.state.pass !== this.state.repass){
            this.setState({
                errorForm: "Pengulangan Password harus sama",
            }, () => alert(this.state.errorForm))
            return 0;
        }
        return 1;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.handleValidation()){
            const o = { variables: {
                token: this.props.token,
                password: this.state.pass,
              }};
      
      
              try {
                await this.props.changePass(o);
                this.setState({
                    pass: '',
                    repass: '',
                    errorForm: '',
                });
                window.location = '/signin';
              }
                  catch (e) {
              }
        }

    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className="container-fluid m-0 p-0">
                    <div className="signcontain">
                        <div className="row m-0 p-0 row1">
                            <div className="col-md-6 logcol p-0 m-0">
                                <div className="login-box">
                                    <h1>Change Password</h1>
                                    <div className="textbox">
                                        <FaLock className="pass"/>
                                        <input
                                            name="pass"
                                            type="password"
                                            placeholder="Password"
                                            onChange={this.handleInputChange}
                                            value={this.state.pass}
                                        />
                                    </div>
                                    <div className="textbox">
                                        <FaUserLock className="repass"/>
                                        <input
                                            name="repass"
                                            type="password"
                                            placeholder="Ulangi Password"
                                            onChange={this.handleInputChange}
                                            value={this.state.repass}
                                        />
                                    </div>
                                    {/* {this.props.errorLog ?
                                        <p className="errorMsg">{this.props.errorLog}</p>:
                                        <></>
                                    } */}
                                    <button type="submit" className="btn btnsign">Submit</button>
                                </div>
                            </div>
                            <div className="col-md-6 backg m-0 p-0">
                                <div className="background">
                                    <img src={back} alt="logo" className="logoback"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default ChangePass;
